// This file is generated from regions-gen.ts
export var regions = {
    '001': [
        '001',
        '001-status-grouping',
        '002',
        '005',
        '009',
        '011',
        '013',
        '014',
        '015',
        '017',
        '018',
        '019',
        '021',
        '029',
        '030',
        '034',
        '035',
        '039',
        '053',
        '054',
        '057',
        '061',
        '142',
        '143',
        '145',
        '150',
        '151',
        '154',
        '155',
        'AC',
        'AD',
        'AE',
        'AF',
        'AG',
        'AI',
        'AL',
        'AM',
        'AO',
        'AQ',
        'AR',
        'AS',
        'AT',
        'AU',
        'AW',
        'AX',
        'AZ',
        'BA',
        'BB',
        'BD',
        'BE',
        'BF',
        'BG',
        'BH',
        'BI',
        'BJ',
        'BL',
        'BM',
        'BN',
        'BO',
        'BQ',
        'BR',
        'BS',
        'BT',
        'BV',
        'BW',
        'BY',
        'BZ',
        'CA',
        'CC',
        'CD',
        'CF',
        'CG',
        'CH',
        'CI',
        'CK',
        'CL',
        'CM',
        'CN',
        'CO',
        'CP',
        'CQ',
        'CR',
        'CU',
        'CV',
        'CW',
        'CX',
        'CY',
        'CZ',
        'DE',
        'DG',
        'DJ',
        'DK',
        'DM',
        'DO',
        'DZ',
        'EA',
        'EC',
        'EE',
        'EG',
        'EH',
        'ER',
        'ES',
        'ET',
        'EU',
        'EZ',
        'FI',
        'FJ',
        'FK',
        'FM',
        'FO',
        'FR',
        'GA',
        'GB',
        'GD',
        'GE',
        'GF',
        'GG',
        'GH',
        'GI',
        'GL',
        'GM',
        'GN',
        'GP',
        'GQ',
        'GR',
        'GS',
        'GT',
        'GU',
        'GW',
        'GY',
        'HK',
        'HM',
        'HN',
        'HR',
        'HT',
        'HU',
        'IC',
        'ID',
        'IE',
        'IL',
        'IM',
        'IN',
        'IO',
        'IQ',
        'IR',
        'IS',
        'IT',
        'JE',
        'JM',
        'JO',
        'JP',
        'KE',
        'KG',
        'KH',
        'KI',
        'KM',
        'KN',
        'KP',
        'KR',
        'KW',
        'KY',
        'KZ',
        'LA',
        'LB',
        'LC',
        'LI',
        'LK',
        'LR',
        'LS',
        'LT',
        'LU',
        'LV',
        'LY',
        'MA',
        'MC',
        'MD',
        'ME',
        'MF',
        'MG',
        'MH',
        'MK',
        'ML',
        'MM',
        'MN',
        'MO',
        'MP',
        'MQ',
        'MR',
        'MS',
        'MT',
        'MU',
        'MV',
        'MW',
        'MX',
        'MY',
        'MZ',
        'NA',
        'NC',
        'NE',
        'NF',
        'NG',
        'NI',
        'NL',
        'NO',
        'NP',
        'NR',
        'NU',
        'NZ',
        'OM',
        'PA',
        'PE',
        'PF',
        'PG',
        'PH',
        'PK',
        'PL',
        'PM',
        'PN',
        'PR',
        'PS',
        'PT',
        'PW',
        'PY',
        'QA',
        'QO',
        'RE',
        'RO',
        'RS',
        'RU',
        'RW',
        'SA',
        'SB',
        'SC',
        'SD',
        'SE',
        'SG',
        'SH',
        'SI',
        'SJ',
        'SK',
        'SL',
        'SM',
        'SN',
        'SO',
        'SR',
        'SS',
        'ST',
        'SV',
        'SX',
        'SY',
        'SZ',
        'TA',
        'TC',
        'TD',
        'TF',
        'TG',
        'TH',
        'TJ',
        'TK',
        'TL',
        'TM',
        'TN',
        'TO',
        'TR',
        'TT',
        'TV',
        'TW',
        'TZ',
        'UA',
        'UG',
        'UM',
        'UN',
        'US',
        'UY',
        'UZ',
        'VA',
        'VC',
        'VE',
        'VG',
        'VI',
        'VN',
        'VU',
        'WF',
        'WS',
        'XK',
        'YE',
        'YT',
        'ZA',
        'ZM',
        'ZW',
    ],
    '002': [
        '002',
        '002-status-grouping',
        '011',
        '014',
        '015',
        '017',
        '018',
        '202',
        'AO',
        'BF',
        'BI',
        'BJ',
        'BW',
        'CD',
        'CF',
        'CG',
        'CI',
        'CM',
        'CV',
        'DJ',
        'DZ',
        'EA',
        'EG',
        'EH',
        'ER',
        'ET',
        'GA',
        'GH',
        'GM',
        'GN',
        'GQ',
        'GW',
        'IC',
        'IO',
        'KE',
        'KM',
        'LR',
        'LS',
        'LY',
        'MA',
        'MG',
        'ML',
        'MR',
        'MU',
        'MW',
        'MZ',
        'NA',
        'NE',
        'NG',
        'RE',
        'RW',
        'SC',
        'SD',
        'SH',
        'SL',
        'SN',
        'SO',
        'SS',
        'ST',
        'SZ',
        'TD',
        'TF',
        'TG',
        'TN',
        'TZ',
        'UG',
        'YT',
        'ZA',
        'ZM',
        'ZW',
    ],
    '003': [
        '003',
        '013',
        '021',
        '029',
        'AG',
        'AI',
        'AW',
        'BB',
        'BL',
        'BM',
        'BQ',
        'BS',
        'BZ',
        'CA',
        'CR',
        'CU',
        'CW',
        'DM',
        'DO',
        'GD',
        'GL',
        'GP',
        'GT',
        'HN',
        'HT',
        'JM',
        'KN',
        'KY',
        'LC',
        'MF',
        'MQ',
        'MS',
        'MX',
        'NI',
        'PA',
        'PM',
        'PR',
        'SV',
        'SX',
        'TC',
        'TT',
        'US',
        'VC',
        'VG',
        'VI',
    ],
    '005': [
        '005',
        'AR',
        'BO',
        'BR',
        'BV',
        'CL',
        'CO',
        'EC',
        'FK',
        'GF',
        'GS',
        'GY',
        'PE',
        'PY',
        'SR',
        'UY',
        'VE',
    ],
    '009': [
        '009',
        '053',
        '054',
        '057',
        '061',
        'AC',
        'AQ',
        'AS',
        'AU',
        'CC',
        'CK',
        'CP',
        'CX',
        'DG',
        'FJ',
        'FM',
        'GU',
        'HM',
        'KI',
        'MH',
        'MP',
        'NC',
        'NF',
        'NR',
        'NU',
        'NZ',
        'PF',
        'PG',
        'PN',
        'PW',
        'QO',
        'SB',
        'TA',
        'TK',
        'TO',
        'TV',
        'UM',
        'VU',
        'WF',
        'WS',
    ],
    '011': [
        '011',
        'BF',
        'BJ',
        'CI',
        'CV',
        'GH',
        'GM',
        'GN',
        'GW',
        'LR',
        'ML',
        'MR',
        'NE',
        'NG',
        'SH',
        'SL',
        'SN',
        'TG',
    ],
    '013': ['013', 'BZ', 'CR', 'GT', 'HN', 'MX', 'NI', 'PA', 'SV'],
    '014': [
        '014',
        'BI',
        'DJ',
        'ER',
        'ET',
        'IO',
        'KE',
        'KM',
        'MG',
        'MU',
        'MW',
        'MZ',
        'RE',
        'RW',
        'SC',
        'SO',
        'SS',
        'TF',
        'TZ',
        'UG',
        'YT',
        'ZM',
        'ZW',
    ],
    '015': ['015', 'DZ', 'EA', 'EG', 'EH', 'IC', 'LY', 'MA', 'SD', 'TN'],
    '017': ['017', 'AO', 'CD', 'CF', 'CG', 'CM', 'GA', 'GQ', 'ST', 'TD'],
    '018': ['018', 'BW', 'LS', 'NA', 'SZ', 'ZA'],
    '019': [
        '003',
        '005',
        '013',
        '019',
        '019-status-grouping',
        '021',
        '029',
        '419',
        'AG',
        'AI',
        'AR',
        'AW',
        'BB',
        'BL',
        'BM',
        'BO',
        'BQ',
        'BR',
        'BS',
        'BV',
        'BZ',
        'CA',
        'CL',
        'CO',
        'CR',
        'CU',
        'CW',
        'DM',
        'DO',
        'EC',
        'FK',
        'GD',
        'GF',
        'GL',
        'GP',
        'GS',
        'GT',
        'GY',
        'HN',
        'HT',
        'JM',
        'KN',
        'KY',
        'LC',
        'MF',
        'MQ',
        'MS',
        'MX',
        'NI',
        'PA',
        'PE',
        'PM',
        'PR',
        'PY',
        'SR',
        'SV',
        'SX',
        'TC',
        'TT',
        'US',
        'UY',
        'VC',
        'VE',
        'VG',
        'VI',
    ],
    '021': ['021', 'BM', 'CA', 'GL', 'PM', 'US'],
    '029': [
        '029',
        'AG',
        'AI',
        'AW',
        'BB',
        'BL',
        'BQ',
        'BS',
        'CU',
        'CW',
        'DM',
        'DO',
        'GD',
        'GP',
        'HT',
        'JM',
        'KN',
        'KY',
        'LC',
        'MF',
        'MQ',
        'MS',
        'PR',
        'SX',
        'TC',
        'TT',
        'VC',
        'VG',
        'VI',
    ],
    '030': ['030', 'CN', 'HK', 'JP', 'KP', 'KR', 'MN', 'MO', 'TW'],
    '034': ['034', 'AF', 'BD', 'BT', 'IN', 'IR', 'LK', 'MV', 'NP', 'PK'],
    '035': [
        '035',
        'BN',
        'ID',
        'KH',
        'LA',
        'MM',
        'MY',
        'PH',
        'SG',
        'TH',
        'TL',
        'VN',
    ],
    '039': [
        '039',
        'AD',
        'AL',
        'BA',
        'ES',
        'GI',
        'GR',
        'HR',
        'IT',
        'ME',
        'MK',
        'MT',
        'PT',
        'RS',
        'SI',
        'SM',
        'VA',
        'XK',
    ],
    '053': ['053', 'AU', 'CC', 'CX', 'HM', 'NF', 'NZ'],
    '054': ['054', 'FJ', 'NC', 'PG', 'SB', 'VU'],
    '057': ['057', 'FM', 'GU', 'KI', 'MH', 'MP', 'NR', 'PW', 'UM'],
    '061': ['061', 'AS', 'CK', 'NU', 'PF', 'PN', 'TK', 'TO', 'TV', 'WF', 'WS'],
    '142': [
        '030',
        '034',
        '035',
        '142',
        '143',
        '145',
        'AE',
        'AF',
        'AM',
        'AZ',
        'BD',
        'BH',
        'BN',
        'BT',
        'CN',
        'CY',
        'GE',
        'HK',
        'ID',
        'IL',
        'IN',
        'IQ',
        'IR',
        'JO',
        'JP',
        'KG',
        'KH',
        'KP',
        'KR',
        'KW',
        'KZ',
        'LA',
        'LB',
        'LK',
        'MM',
        'MN',
        'MO',
        'MV',
        'MY',
        'NP',
        'OM',
        'PH',
        'PK',
        'PS',
        'QA',
        'SA',
        'SG',
        'SY',
        'TH',
        'TJ',
        'TL',
        'TM',
        'TR',
        'TW',
        'UZ',
        'VN',
        'YE',
    ],
    '143': ['143', 'KG', 'KZ', 'TJ', 'TM', 'UZ'],
    '145': [
        '145',
        'AE',
        'AM',
        'AZ',
        'BH',
        'CY',
        'GE',
        'IL',
        'IQ',
        'JO',
        'KW',
        'LB',
        'OM',
        'PS',
        'QA',
        'SA',
        'SY',
        'TR',
        'YE',
    ],
    '150': [
        '039',
        '150',
        '151',
        '154',
        '155',
        'AD',
        'AL',
        'AT',
        'AX',
        'BA',
        'BE',
        'BG',
        'BY',
        'CH',
        'CQ',
        'CZ',
        'DE',
        'DK',
        'EE',
        'ES',
        'FI',
        'FO',
        'FR',
        'GB',
        'GG',
        'GI',
        'GR',
        'HR',
        'HU',
        'IE',
        'IM',
        'IS',
        'IT',
        'JE',
        'LI',
        'LT',
        'LU',
        'LV',
        'MC',
        'MD',
        'ME',
        'MK',
        'MT',
        'NL',
        'NO',
        'PL',
        'PT',
        'RO',
        'RS',
        'RU',
        'SE',
        'SI',
        'SJ',
        'SK',
        'SM',
        'UA',
        'VA',
        'XK',
    ],
    '151': ['151', 'BG', 'BY', 'CZ', 'HU', 'MD', 'PL', 'RO', 'RU', 'SK', 'UA'],
    '154': [
        '154',
        'AX',
        'CQ',
        'DK',
        'EE',
        'FI',
        'FO',
        'GB',
        'GG',
        'IE',
        'IM',
        'IS',
        'JE',
        'LT',
        'LV',
        'NO',
        'SE',
        'SJ',
    ],
    '155': ['155', 'AT', 'BE', 'CH', 'DE', 'FR', 'LI', 'LU', 'MC', 'NL'],
    '202': [
        '011',
        '014',
        '017',
        '018',
        '202',
        'AO',
        'BF',
        'BI',
        'BJ',
        'BW',
        'CD',
        'CF',
        'CG',
        'CI',
        'CM',
        'CV',
        'DJ',
        'ER',
        'ET',
        'GA',
        'GH',
        'GM',
        'GN',
        'GQ',
        'GW',
        'IO',
        'KE',
        'KM',
        'LR',
        'LS',
        'MG',
        'ML',
        'MR',
        'MU',
        'MW',
        'MZ',
        'NA',
        'NE',
        'NG',
        'RE',
        'RW',
        'SC',
        'SH',
        'SL',
        'SN',
        'SO',
        'SS',
        'ST',
        'SZ',
        'TD',
        'TF',
        'TG',
        'TZ',
        'UG',
        'YT',
        'ZA',
        'ZM',
        'ZW',
    ],
    '419': [
        '005',
        '013',
        '029',
        '419',
        'AG',
        'AI',
        'AR',
        'AW',
        'BB',
        'BL',
        'BO',
        'BQ',
        'BR',
        'BS',
        'BV',
        'BZ',
        'CL',
        'CO',
        'CR',
        'CU',
        'CW',
        'DM',
        'DO',
        'EC',
        'FK',
        'GD',
        'GF',
        'GP',
        'GS',
        'GT',
        'GY',
        'HN',
        'HT',
        'JM',
        'KN',
        'KY',
        'LC',
        'MF',
        'MQ',
        'MS',
        'MX',
        'NI',
        'PA',
        'PE',
        'PR',
        'PY',
        'SR',
        'SV',
        'SX',
        'TC',
        'TT',
        'UY',
        'VC',
        'VE',
        'VG',
        'VI',
    ],
    EU: [
        'AT',
        'BE',
        'BG',
        'CY',
        'CZ',
        'DE',
        'DK',
        'EE',
        'ES',
        'EU',
        'FI',
        'FR',
        'GR',
        'HR',
        'HU',
        'IE',
        'IT',
        'LT',
        'LU',
        'LV',
        'MT',
        'NL',
        'PL',
        'PT',
        'RO',
        'SE',
        'SI',
        'SK',
    ],
    EZ: [
        'AT',
        'BE',
        'CY',
        'DE',
        'EE',
        'ES',
        'EZ',
        'FI',
        'FR',
        'GR',
        'IE',
        'IT',
        'LT',
        'LU',
        'LV',
        'MT',
        'NL',
        'PT',
        'SI',
        'SK',
    ],
    QO: ['AC', 'AQ', 'CP', 'DG', 'QO', 'TA'],
    UN: [
        'AD',
        'AE',
        'AF',
        'AG',
        'AL',
        'AM',
        'AO',
        'AR',
        'AT',
        'AU',
        'AZ',
        'BA',
        'BB',
        'BD',
        'BE',
        'BF',
        'BG',
        'BH',
        'BI',
        'BJ',
        'BN',
        'BO',
        'BR',
        'BS',
        'BT',
        'BW',
        'BY',
        'BZ',
        'CA',
        'CD',
        'CF',
        'CG',
        'CH',
        'CI',
        'CL',
        'CM',
        'CN',
        'CO',
        'CR',
        'CU',
        'CV',
        'CY',
        'CZ',
        'DE',
        'DJ',
        'DK',
        'DM',
        'DO',
        'DZ',
        'EC',
        'EE',
        'EG',
        'ER',
        'ES',
        'ET',
        'FI',
        'FJ',
        'FM',
        'FR',
        'GA',
        'GB',
        'GD',
        'GE',
        'GH',
        'GM',
        'GN',
        'GQ',
        'GR',
        'GT',
        'GW',
        'GY',
        'HN',
        'HR',
        'HT',
        'HU',
        'ID',
        'IE',
        'IL',
        'IN',
        'IQ',
        'IR',
        'IS',
        'IT',
        'JM',
        'JO',
        'JP',
        'KE',
        'KG',
        'KH',
        'KI',
        'KM',
        'KN',
        'KP',
        'KR',
        'KW',
        'KZ',
        'LA',
        'LB',
        'LC',
        'LI',
        'LK',
        'LR',
        'LS',
        'LT',
        'LU',
        'LV',
        'LY',
        'MA',
        'MC',
        'MD',
        'ME',
        'MG',
        'MH',
        'MK',
        'ML',
        'MM',
        'MN',
        'MR',
        'MT',
        'MU',
        'MV',
        'MW',
        'MX',
        'MY',
        'MZ',
        'NA',
        'NE',
        'NG',
        'NI',
        'NL',
        'NO',
        'NP',
        'NR',
        'NZ',
        'OM',
        'PA',
        'PE',
        'PG',
        'PH',
        'PK',
        'PL',
        'PT',
        'PW',
        'PY',
        'QA',
        'RO',
        'RS',
        'RU',
        'RW',
        'SA',
        'SB',
        'SC',
        'SD',
        'SE',
        'SG',
        'SI',
        'SK',
        'SL',
        'SM',
        'SN',
        'SO',
        'SR',
        'SS',
        'ST',
        'SV',
        'SY',
        'SZ',
        'TD',
        'TG',
        'TH',
        'TJ',
        'TL',
        'TM',
        'TN',
        'TO',
        'TR',
        'TT',
        'TV',
        'TZ',
        'UA',
        'UG',
        'UN',
        'US',
        'UY',
        'UZ',
        'VC',
        'VE',
        'VN',
        'VU',
        'WS',
        'YE',
        'ZA',
        'ZM',
        'ZW',
    ],
};
